import pureInitLayout from './initLayout';
import pureSetLayoutProperty from './setLayoutProperty';
import pureMergeLayoutProperty from './mergeLayoutProperty';
import pureShowLayoutComponent from './showLayoutComponent';
import pureHideLayoutComponent from './hideLayoutComponent';
import pureBatchLayoutOperations from './batchLayoutOperations';
import store from '../../../../store';

const withDispatch = pureAction => (context, event, meta) => {
  store.dispatch(pureAction(context, event, meta));
};

export const initLayout = withDispatch(pureInitLayout);
export const setLayoutProperty = withDispatch(pureSetLayoutProperty);
export const mergeLayoutProperty = withDispatch(pureMergeLayoutProperty);
export const showLayoutComponent = withDispatch(pureShowLayoutComponent);
export const hideLayoutComponent = withDispatch(pureHideLayoutComponent);
export const batchLayoutOperations = withDispatch(pureBatchLayoutOperations);
